import { gql } from '@apollo/client';

export default gql`
  mutation changePendingTravelPassDates($bookingReference: String!, $newEndDate: String!, $newStartDate: String!) {
    changePendingTravelPassDates(bookingReference: $bookingReference, newEndDate: $newEndDate, newStartDate: $newStartDate)
  }
`;
